import React from 'react'
import {Check, Info, Shield} from 'lucide-react'
import { cn } from '../../lib/utils'

interface MicroTextProps {
  type?: 'info' | 'success' | 'trust'
  children: React.ReactNode
  className?: string
}

export function MicroText({ type = 'info', children, className }: MicroTextProps) {
  const icons = {
    info: Info,
    success: Check,
    trust: Shield
  }

  const colors = {
    info: 'text-blue-600',
    success: 'text-green-600',
    trust: 'text-green-700'
  }

  const Icon = icons[type]

  return (
    <div className={cn("flex items-start space-x-2 text-xs", className)}>
      <Icon className={cn("h-3.5 w-3.5 flex-shrink-0 mt-0.5", colors[type])} />
      <span className="text-gray-600 leading-relaxed">{children}</span>
    </div>
  )
}
